import { Components, Theme } from '@mui/material';
import { getDenseResponsiveFontSize } from '../watchdutyTheme.utils';

export const getMuiBadge = (theme: Theme): Components['MuiBadge'] => ({
  styleOverrides: {
    badge: {
      variants: [
        {
          props: { variant: 'standard' },
          style: {
            height: 'auto',
            minWidth: theme.spacing(2),
            padding: '2px 4px',
            borderRadius: theme.spacing(0.5),
            fontSize: getDenseResponsiveFontSize('0.75rem'),
            fontWeight: theme.typography.fontWeightBold,
            lineHeight: 'normal',

            // A badge with nothing to anchor to sits inline
            '&:only-child': {
              position: 'static',
              transform: 'none',
              '&.MuiBadge-invisible': {
                display: 'none',
              },
            },
          },
        },
        {
          props: { color: 'default' },
          style: {
            backgroundColor: 'var(--mui-palette-alert-moderate-main)',
            color: 'var(--mui-palette-background-default)',
          },
        },
      ],
    },
  },
});
